import React from 'react';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { formatNumber } from 'src/utils/numberFormater';

interface Props {
  riskIndex: number;
  options: ContributionOptionExclusive[];
  isColorBlindMode?: boolean;
}

const RiskInfoComponent = ({ riskIndex, options, isColorBlindMode }: Props) => {
  if (!(riskIndex && options)) {
    return null;
  }

  const hasBenefitExclusion =
    options[riskIndex - 1]?.orderAcceptedBenefitExclusion;
  const hasAdditionalFee = options[riskIndex - 1]?.orderAcceptedAdditionalFee;
  const hasDifferentFee = options[riskIndex - 1]?.orderAcceptedDifferentFee;
  const hasDifferentFeeReason =
    options[riskIndex - 1]?.orderAcceptedAdditionalFeeReason;
  const hasFee = options[riskIndex - 1]?.fee;

  if (hasBenefitExclusion || hasAdditionalFee || hasDifferentFee) {
    return (
      <>
        <Typography
          variant="h6"
          sx={{ py: 3, pr: 5, fontWeight: 'bold', whiteSpace: 'nowrap' }}
        >
          {hasBenefitExclusion
            ? hasAdditionalFee
              ? 'Leistungsausschluss und Beitragsanpassung:'
              : 'Leistungsausschluss:'
            : 'Beitragsanpassung:'}
        </Typography>
        {hasBenefitExclusion && (
          <Alert
            severity="warning"
            sx={{
              width: '100%',
              alignItems: 'center',
              marginY: 1,
              backgroundColor: 'statusColors.alert.bgColor',
              ...(isColorBlindMode && {
                border: '1px solid black',
                '& .MuiAlert-icon': { color: 'black' },
                '& .MuiAlert-message': { color: 'black' },
              }),
            }}
          >
            <Typography>
              Der Versicherer informiert über folgende Leistungsaussschlüsse:{' '}
              {hasBenefitExclusion}
            </Typography>
          </Alert>
        )}
        {(hasAdditionalFee || hasDifferentFee) && (
          <Alert
            severity="warning"
            sx={{
              width: '100%',
              alignItems: 'center',
              marginBottom: 2,
              backgroundColor: 'statusColors.alert.bgColor',
              ...(isColorBlindMode && {
                border: '1px solid black',
                '& .MuiAlert-icon': { color: 'black' },
                '& .MuiAlert-message': { color: 'black' },
              }),
            }}
          >
            {hasDifferentFeeReason && (
              <Typography>
                Der Versicherer erhebt einen Risikozuschlag in Höhe von:{' '}
                {hasAdditionalFee ??
                  (hasDifferentFee &&
                    `${formatNumber(
                      parseFloat(hasDifferentFee?.replace(',', '.')) - hasFee
                    )} €`)}
              </Typography>
            )}
            {hasDifferentFeeReason && (
              <Typography>
                Die Begründung des Versicherers lautet: {hasDifferentFeeReason}.
              </Typography>
            )}
            <Typography>
              Der Beitrag wurde aufgrund der gemachten Angaben angepasst und
              lautet insgesamt: {hasDifferentFee}
            </Typography>
          </Alert>
        )}
      </>
    );
  }

  return null;
};

export default RiskInfoComponent;
